import { Auth } from 'aws-amplify'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { authenticateUser } from '../API/authentication'
import Splash from '../modules/Authentication/Splash'

export const BootstrapApp = ({ children }) => {
  const [isAppReady, setAppReady] = React.useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  React.useEffect(() => {
    const init = async () => {
      try {
        const rememberMe = localStorage.getItem('rememberMe')
        Auth.configure({
          storage: rememberMe ? window.localStorage : window.sessionStorage
        })
        const isAuthenticated = await authenticateUser()
        setAppReady(true)

        const publicPaths = ['/forgot-password', '/enter-reset-code', '/create-account', '/learn-more']
        if (/^\/fit\/[^/]+$/.test(location.pathname) || publicPaths.includes(location.pathname)) {
          return
        }

        if (isAuthenticated) {
          navigate(
            location.pathname === '/signin' || !location.pathname
              ? '/'
              : location.pathname
          )
        } else {
          navigate('/signin')
        }
      } catch (e) {
        setAppReady(true)
        navigate('/signin')
      }
    }

    init()
  }, [])

  return isAppReady ? <>{children}</> : <Splash />
}
